import React, {useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';

import "../Pagina.css";
import "../content-styles.css"
import "./Downloads.css"

import * as Hosts from '../../../Hosts';
import {
	reqGET,
	reqPUT,
	reqPOST,
	reqFILE,
    profile_access,
    functionSendMail
} from '../../../Utils';

import { usarToken } from "../../../UseToken";

import Loader from '../../../loader'

import Navbar from "../Navbar/Navbar_00";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Footer from "../Footer/Footer_00";

import { language } from './Language';

export default function Downloads(props) {

    const [, set_dados] = useState(null);
    const is_logged_in = useRef(null);
    const downloads_list = useRef(null);
    const downloads_section_list = useRef(null);
    const downloads_section_selected = useRef(null);
    const clients_list = useRef(null);
    const client_selected = useRef(null);
      
    const [dados_config, set_dados_config] = useState({});
    const [dados_navbar, set_dados_navbar] = useState({});

    const sections = useRef(null);
    const downloads_by_section = useRef(null);

    const [files_to_upload, set_files_to_upload] = useState([]);
    const [loading_table, set_loading_table] = useState(false);

    const [type, ] = useState('download')
    const [insert_section, set_insert_section] = useState(false)
    const [new_section, set_new_section] = useState('')

    const [user_info, set_user_info] = useState({})

    const [user_name_by_id, set_user_name_by_id] = useState([])
    const [user_access_level, set_user_access_level] = useState(0)

    const [isloading, setLoading] = useState(true)
    const [refresh, setRefresh] = useState(0)

    const [is_edit, set_is_edit] = useState(false)
    const [files_uploading, set_files_uploading] = useState(false)

    const [lang, set_lang] = useState('pt')

    useEffect(() => {

        (async () => {

            set_dados(downloads_list.current = [])
            set_dados(downloads_section_list.current = [])
            set_dados(downloads_section_selected.current = '')
            set_dados(clients_list.current = [])

            let temp_token_info = await usarToken().getToken()
            let token_info = JSON.parse(temp_token_info)
            
            if(token_info !== undefined && token_info !== null && token_info.user_info !== undefined) {
                set_dados(is_logged_in.current = true)
            }
            else {
                set_dados(is_logged_in.current = false)
            }

            if(is_logged_in.current) {
                if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
                    set_dados_navbar(props.dados_navbar)
                }
            }

            if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
                set_dados_config(props.dados_config)
            }

            let getClientDownloads = async (id_user) => {

                if(client_selected.current !== undefined && client_selected.current !== null && client_selected.current !== '') {

                }
                else {
                    set_dados(client_selected.current = {id: id_user, info: {name: token_info.user_info.name}})
                }

                let downloads = await reqGET(`${Hosts.SIMCore_API}/web/relation/user/${Hosts.companycode}/${id_user}/downloads`)
                let sections_aux = []
                let downloads_by_section_aux = []
                if(downloads.data !== undefined && downloads.data !== null && downloads.data.length > 0) {
                    for await (let el of downloads.data) {
                        if(sections_aux.filter(el_s => el_s === el.info.section).length === 0) {
                            sections_aux.push(el.info.section)
                        }
                        if(downloads_by_section_aux[sections_aux.indexOf(el.info.section)] === undefined) {
                            downloads_by_section_aux[sections_aux.indexOf(el.info.section)] = []
                        }
                        downloads_by_section_aux[sections_aux.indexOf(el.info.section)].push(el)
                    }

                    set_dados(downloads_list.current = downloads.data)
                    set_dados(downloads_section_list.current = sections_aux)
                    set_dados(downloads_by_section.current = downloads_by_section_aux)

                    setLoading(false)
                }
                else {
                    setLoading(false)
                }

            }
            let getCollaboratorDownloads = async () => {

                let clients = await reqGET(`${Hosts.SIMCore_API}/entities/special/${Hosts.companycode}/Cliente`)

                if(clients.data !== undefined && clients.data !== null) {
                    set_dados(clients_list.current = clients.data)
                }
                
                setLoading(false)

            }
            if (token_info !== undefined && token_info !== null && token_info.user_info !== undefined && token_info.user_info !== null && token_info.user_info.id !== '') {

                let profile_access_aux = profile_access.find(el => el.name.toLowerCase() === token_info.user_info.profile.toLowerCase())
                if(profile_access_aux !== undefined && profile_access_aux !== null) {
                    set_user_access_level(profile_access_aux.level)
                }

                set_user_info(token_info.user_info)

                if(parseInt(profile_access_aux.level) >= 5) {
                    await getCollaboratorDownloads()

                    if(client_selected.current !== undefined && client_selected.current !== null && client_selected.current !== undefined) {
                        await getClientDownloads(client_selected.current.id)
                    }
                }
                else {
                    await getClientDownloads(token_info.user_info.id)
                }

            }

        })()

        if(localStorage.getItem('lang') !== undefined  || localStorage.getItem('lang') !== null) {
            set_lang(localStorage.getItem('lang'))
        }

    }, [props, refresh]);

    const handleSubmit = async (e) => {
		e.preventDefault();


        if(is_edit) {

            console.log('edit')

        }
        else {
            
            console.log('insert')

        }

	}

    const add_downloads = async (id_user) => {

    }

    const show_download = async (id_user) => {

        let client = await reqGET(`${Hosts.SIMCore_API}/entities/${Hosts.companycode}/${id_user}`)
        if(client.data !== undefined && client.data !== null && client.data.length === 1) {
            set_dados(client_selected.current = client.data[0])

            set_loading_table(true)

            let downloads = await reqGET(`${Hosts.SIMCore_API}/web/relation/user/${Hosts.companycode}/${id_user}/downloads`)

            let sections_aux = []
            let downloads_by_section_aux = []
            if(downloads.data !== undefined && downloads.data !== null && downloads.data.length > 0) {
                downloads.data.forEach(el => {
                    if(sections_aux.filter(el_s => el_s === el.info.section).length === 0) {
                        sections_aux.push(el.info.section)
                    }

                    if(downloads_by_section_aux[sections_aux.indexOf(el.info.section)] === undefined) {
                        downloads_by_section_aux[sections_aux.indexOf(el.info.section)] = []
                    }
                    downloads_by_section_aux[sections_aux.indexOf(el.info.section)].push(el)
                })
            }

            set_dados(downloads_list.current = downloads.data)
            set_dados(downloads_section_list.current = sections_aux)
            set_dados(downloads_by_section.current = downloads_by_section_aux)

            set_loading_table(false)
        }

    }

    const add_section = () => {

        let x = downloads_section_list.current.filter(el => el === new_section)
        if(x !== undefined && x !== null && x.length > 0) {
        }
        else {
            set_dados(downloads_section_list.current.push(new_section))
        }

    }

    const handle_change_section = (e) => {
        const { value } = e.target;

        set_dados(downloads_section_selected.current = value)

    }

    const onChangeHandlerFile = (e) => {
        const { files } = e.target;

        console.log('files', files)

        let storedFiles = []
		let filesArray = Array.prototype.slice.call(files)
        filesArray.forEach((v) => {
            storedFiles.push(v)
        })

        let files_aux = files_to_upload
		files_aux.push({ files: storedFiles, section: downloads_section_selected.current })
		set_files_to_upload(files_aux)

        // handleFileUpload(e);
    }
    
    const send_files = async () => {

        set_files_uploading(true)
        console.log('files_to_upload', files_to_upload)
        for await(let el of files_to_upload) {
            for await (let el_files of el.files) {

                await uploadFile(el_files, el.section)

            }
        }
        set_files_to_upload([])

        let today = new Date();
        let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();

        let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +'; border:1px solid transparent; border-collapse:collapse;">' +
            '<tr style="border-collapse: collapse;">' +
                '<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                    '<div>' +
                        '<span><b>' + language[lang].downloads + '</b></span>' +
                    '</div>' +
                '</td>' + 
                '<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                    '<div>'+
                        '<span>'+ today_aux + '</span>'+
                    '</div>'+
                '</td>' +
            '</tr>' +

            '<tr>' +
                '<td colspan="2" align="right" style="height: 15px;"></td>' +
            '</tr>' +

            '<tr style="border-collapse: collapse;">' +
                '<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                    '<div>'+
                        '<span>' + language[lang].downloads_email_sent + '</span>'+
                    '</div>'+
                '</td>' +
            '</tr>' +

            '<tr style="border-collapse: collapse;">' +
                '<td colspan="2" align="left" style="padding:0px 40px;border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                    '<div>'+
                        language[lang].access_app_txt +  ' <a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">'+ language[lang].access_app_link +'</a>'+
                    '</div>'+
                '</td>' +
            '</tr>' +
            
            '<tr>' +
                '<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
            '</tr>' +
        '</table>'

        let sendFrom = Hosts.contactFrom
        let sendTo = [user_info.username]
        let sendToCC = ['web.dev@assec.pt']
        let subject = language[lang].subject_downloads_email
        let content = mail_content
        let attachment = []

        await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment, dados_config)

        setRefresh(r => r + 1)
        set_files_uploading(false)

    }

    const uploadFile = async (file, section) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', client_selected.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'customer')
		formData.append('companycode', Hosts.companycode)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/customer/');

		return await reqFILE(`${Hosts.SIMCore_API}/multimedia/file`, formData)
			.then(async (res) => {
				var today_file = new Date()

				let doc = {
					id: '',
					info: {
						companycode: Hosts.companycode,
                        id_user: client_selected.current.id,
                        id_user_sent: user_info.id,
                        name: file.name,
                        url: res.data.path + '/' + res.data.name,
                        relation: 'downloads',
                        section: section,
						type: res.data.mimetype,
						size: res.data.size,
						date: today_file,
                        visible: true
					}
				}
				
				await reqPOST(`${Hosts.SIMCore_API}/web/relation`, doc)

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}
    
    const set_read = async (id, id_user) => {
        
        if(parseInt(user_info.id) === parseInt(id_user)) {
            await reqGET(`${Hosts.SIMCore_API}/web/relation/read/${Hosts.companycode}/${id}`)
        }

    }

    const back_clean_arrays = () => {
        set_dados(client_selected.current = null); 
        set_dados(downloads_by_section.current = null);
    }

    const columns = [
        {
            name: language[lang].field_name,
            selector: 'info.name',
            sortable: true,
            left: true,
            maxWidth: '90%',
            minWidth: '250px',
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            minWidth: '150px',
            maxWidth: '10%',
            cell: row => 
                <span>
                    <i className="bi bi-folder me-3 fs-5" style={{cursor: 'pointer'}} onClick={() => show_download(row.id)}></i>
                    <i className="bi bi-folder-plus fs-5 d-none" style={{cursor: 'pointer'}} onClick={() => add_downloads(row.id)}></i>
                </span>
        },
    ]

    const columns_downloads = [
        {
            name: language[lang].field_name,
            selector: 'info.name',
            wrap: true,
            sortable: true,
            left: true,
            width: '55%',
            minWidth: '200px',
        },
        // {
        //     name: language[lang].section,
        //     selector: 'info.section',
        //     sortable: true,
        //     left: true,
        //     width: '10%',
        //     minWidth: '150px',
        // },
        {
            name: language[lang].field_date,
            selector: 'info.date',
            sortable: true,
            center: true,
            width: '15%',
            minWidth: '180px',
            cell: row => 
                <span style={{fontVariantNumeric: 'tabular-nums'}}>
                    {row.info.date}
                </span>
        },
        {
            name: language[lang].field_date_read,
            selector: 'info.read_date',
            sortable: true,
            center: true,
            width: '15%',
            minWidth: '180px',
        },
        // {
        //     name: '',
        //     sortable: false,
        //     center: true,
        //     width: '5%',
        //     minWidth: '50px',
        //     cell: row => 
        //         <span>
        //             {
        //             parseInt(row.info.id_user) === parseInt(row.info.id_user_sent) ?
        //                 <i className="bi bi-file-earmark-arrow-up-fill fs-5" style={{color: 'var(--primary)'}}></i>
        //             :
        //                 <i className="bi bi-file-earmark-arrow-down fs-5" style={{color: 'var(--primary)'}}></i>
        //             }
        //         </span>
        // },
        {
            name: '',
            center: true,
            export: false,
            print: false,
            width: '5%',
            minWidth: '80px',
            cell: row => 
                <span>
                    <a href={row.info.base64} download={row.info.name} title={language[lang].download} alt={language[lang].download} onClick={() => set_read(row.id, row.info.id_user)}>
                        <i className="bi bi-download me-3 fs-5"></i>
                    </a>
                </span>
        },
    ]

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    }

    return (
        isloading ?
            <Loader />
        :
        <>
            <Navbar pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />

            <Breadcrumb /> 

            <div className="container-fluid">
                <div className="row">
                    <div className='col-12 bg-light py-5'>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-12 col-lg-10'>
                                    <h3 className="titulo-primario">
                                        <span>{language[lang].downloads}</span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row mb-5'>
                    <div className='col-12'>
                        <div className="container">
                            <div className='row mb-5'>

                                <div className='col-12 col-lg-8 mx-auto'>
                                    {
                                    client_selected.current !== undefined && client_selected.current !== null && client_selected.current.id !== '' ?
                                        <div className="row mb-3">
                                            {
                                            files_uploading ? 
                                                <div className='col-12 text-center'>
                                                    <Loader />
                                                </div>
                                            :
                                                null
                                            }
                                            <div className='col-12 pt-5'>
                                                <h5>
                                                    <i className="bi bi-person-circle me-3"></i>
                                                    {client_selected.current.info.name}
                                                </h5>
                                            </div> 
                                            <div className='col-12 mx-auto mt-5 text-end'>
                                                {
                                                parseInt(user_access_level) >= 5 ?
                                                    <button type="button" className='btn btn-light rounded-0 me-2' onClick={() => back_clean_arrays()}>
                                                        {language[lang].back}
                                                    </button>
                                                :
                                                    null
                                                }
                                                {
                                                parseInt(user_access_level) >= 5 ?
                                                    <button type="button" className='btn btn-secondary' data-bs-toggle="modal" data-bs-target=".modal-add-downloads" onClick={() => add_downloads()}>
                                                        {language[lang].downloads_add}
                                                    </button>
                                                :
                                                    null
                                                }
                                            </div>
                                            
                                            <div className='col-12'>
                                                <ul className="nav nav-pills mb-3" role="tablist">
                                                    {
                                                    downloads_by_section.current !== undefined && downloads_by_section.current !== null ?
                                                        downloads_by_section.current.map((el_dbs, k_dbs) => {
                                                            return (
                                                                <li key={k_dbs} className="nav-item" role="presentation">
                                                                    <button type="button" role="tab" className={"nav-link rounded-0 py-1 px-2" + (k_dbs === 0 ? " active" : "")} id={"pills_page_" + k_dbs +"_tab"} data-bs-toggle="pill" data-bs-target={"#pills_page_" + k_dbs} aria-controls={"pills_page_" + k_dbs}>
                                                                        {el_dbs[0].info.section}
                                                                    </button>
                                                                </li>
                                                            )
                                                        })
                                                    :
                                                        null
                                                    }
                                                </ul>

                                                <div className='tab-content'>
                                                    {
                                                    downloads_by_section.current !== undefined && downloads_by_section.current !== null ?
                                                        downloads_by_section.current.map((el_dbs, k_dbs) => {
                                                            return (
                                                                <div key={k_dbs} className={"tab-pane fade" + (k_dbs === 0 ? " show active" : '')} id={"pills_page_" + k_dbs} aria-labelledby={"pills_page_" + k_dbs +"_tab"} role="tabpanel" tabIndex="0">
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            <div key={k_dbs} className='table-body table-downloads py-5'>
                                                                                <h5 className='mb-3 d-none'>{el_dbs[0].info.section}</h5>
                                                                                <DataTable
                                                                                    columns={columns_downloads}
                                                                                    data={el_dbs}
                                                                                    noDataComponent={loading_table ? language[lang].table_loading : language[lang].table_empty}
                                                                                    noHeader
                                                                                    pagination
                                                                                    exportHeaders
                                                                                    paginationComponentOptions={defaultComponentOptions}
                                                                                    paginationPerPage={25}
                                                                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    :
                                                        <div className='table-body table-downloads py-5'>
                                                            <DataTable
                                                                columns={columns_downloads}
                                                                data={downloads_list.current}
                                                                noDataComponent={loading_table ? language[lang].table_loading : language[lang].table_empty}
                                                                noHeader
                                                                pagination
                                                                exportHeaders
                                                                paginationComponentOptions={defaultComponentOptions}
                                                                paginationPerPage={25}
                                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                            <div className="modal fade modal-add-downloads" tabIndex="-1" role="dialog" aria-labelledby="my-largeModalLabel" aria-hidden="true">
                                                <div className="modal-dialog modal-xl">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title" id="exampleModalLabel">{language[lang].downloads_add}</h5>
                                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                        </div>

                                                        <div className="modal-body py-4 px-5">
                                                            <div className='col-12 d-flex'>
                                                                <button type="button" className='btn btn-secondary rounded-0' onClick={() => set_insert_section(true)}>
                                                                    {language[lang].section_new} <i className="bi bi-plus"></i>
                                                                </button>
                                                                {
                                                                insert_section ?
                                                                    <div className="input-group w-50 ms-2">
                                                                        <input type="text" className="form-control rounded-0" placeholder={language[lang].section_name_placeholder} aria-label={language[lang].section_name_placeholder} aria-describedby="button-add-section" onChange={(e) => set_new_section(e.target.value)} />
                                                                        <button id="button-add-section" className="btn btn-outline-secondary rounded-0" type="button" onClick={() => add_section()} >{language[lang].save}</button>
                                                                    </div>
                                                                :
                                                                    null
                                                                }
                                                            </div>
                                                            
                                                            <div className='col-12 col-sm-6 mt-4'>
                                                                <label className="form-label">{language[lang].section} *</label>
                                                                <select className="form-select rounded-0" aria-label="Select section" name='section' value={downloads_section_selected.current} onChange={(e) => handle_change_section(e)}>
                                                                    <option value="">{language[lang].section_choose}</option>
                                                                    {
                                                                    downloads_section_list.current.map((v, k) => {
                                                                        return (
                                                                            <option key={k} value={v}>{v}</option>
                                                                        )
                                                                    })
                                                                    }
                                                                </select>
                                                            </div>

                                                            {
                                                            downloads_section_selected.current !== '' ?
                                                                <div className='col-12 col-sm-6  mt-4'>
                                                                    <label htmlFor="btn-add-files" className="form-label">{language[lang].downloads_add}</label>
                                                                    <input 
                                                                        className="form-control rounded-0" 
                                                                        type="file" 
                                                                        id="btn-add-files"                                         
                                                                        onChange={onChangeHandlerFile}
                                                                        multiple 
                                                                    />
                                                                </div>
                                                            :
                                                                null
                                                            }
                                                        </div>

                                                        <div className="modal-footer">
                                                            <button type="button" className="btn btn-secondary px-4" data-bs-dismiss="modal" onClick={() => send_files()}> {language[lang].send} </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    :
                                        <div className='row mb-2'>
                                            <div className='col-12'>
                                                <div className="table-body py-5 d-none">
                                                    <DataTable
                                                        columns={columns}
                                                        data={clients_list.current}
                                                        noDataComponent={loading_table ? language[lang].table_loading : language[lang].table_empty}
                                                        noHeader
                                                        pagination
                                                        exportHeaders
                                                        paginationComponentOptions={defaultComponentOptions}
                                                        paginationPerPage={25}
                                                        paginationRowsPerPageOptions={[25, 50, 100]}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <Footer pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
        </>

    );
}

